import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { Header } from '@/layouts/Header';
import { PageContainer, PageContent } from '@/layouts/Page';

import { LayoutTabs } from './LayoutTabs';

export const Layout = () => {
  const { t } = useTranslation('specifications-contract');
  return (
    <PageContainer
      title={t('detail.layout.title')}
      meta={
        <Fragment>
          <script defer src="/e-imzo/e-imzo.js"></script>
          <script defer src="/e-imzo/e-imzo-client.js"></script>
        </Fragment>
      }
    >
      <Header hasBreadcrumbs />
      <LayoutTabs />
      <PageContent>
        <Outlet />
      </PageContent>
    </PageContainer>
  );
};
